import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";

class CloseLanguageDropdownAction extends BaseAction<void, void> {
    override async run(): Promise<void> {
        try {
            updateRecoilState("languageDropdownOpenAtom", false);
        } catch (error: any) {
            console.error("Error closing language dropdown:", error);
        }
    }
}

export const closeLanguageDropdownAction = new CloseLanguageDropdownAction();
